import { cn, hasMessage } from '@/lib/utils';
import { MutableRefObject } from 'react';
import type { FileWithPath } from 'react-dropzone';

import { FileSpec, IThread, useChatMessages } from '@chainlit/react-client';

import WaterMark from '@/components/WaterMark';

import MessageComposer from './MessageComposer';
import StopButton from './StopButton';

interface Props {
  fileSpec: FileSpec;
  onFileUpload: (payload: FileWithPath[]) => void;
  onFileUploadError: (error: string) => void;
  autoScrollRef: MutableRefObject<boolean>;
  showIfEmptyThread?: boolean;
  thread?: IThread;
}

export default function ChatFooter({ showIfEmptyThread, thread, ...props }: Props) {
  const { messages } = useChatMessages();
  return (
    <div className={cn('relative flex flex-col items-center gap-2 w-full')}>
      <StopButton />
      <MessageComposer {...props} thread={thread} />
      <WaterMark />
    </div>
  );
}
